import { render, staticRenderFns } from "./RedesignExtensionCardBody.vue?vue&type=template&id=59e65fdb"
import script from "./RedesignExtensionCardBody.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignExtensionCardBody.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignExtensionCardBody.vue?vue&type=style&index=0&id=59e65fdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports